// Set custom delimiter tags for use in mustache.js templates
Mustache.tags = ['[[',']]'];
